import React from 'react'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import FullImage from '../../components/inner/venderProduct/FullImage'
import ImageTextPanel from '../../components/inner/technologies/ImageTextPanel'

import AutomotiveImage01 from '../../assets/technologies/automotiveImage01.png'
import AutomotiveImage02 from '../../assets/technologies/automotiveImage02.png'
import AutomotiveImage03 from '../../assets/technologies/automotiveImage03.png'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';


const Automotive = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.automotive || siteCopy.en.pages.technologies.automotive;
  const solutionCopy = copy.solution || siteCopy.en.pages.technologies.automotive.solution;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>

        <div style={{height: '60px'}}/>
        
        <HeaderContentSmall>
          {renderLines(copy.introParagraphs)}
        </HeaderContentSmall>
        <HeaderContentSmall>
          {renderLines(copy.secondParagraphs)}
        </HeaderContentSmall>

        <FullImage Item={AutomotiveImage01}/>

        <SubHeading>{copy.highlightsTitle}</SubHeading>
        <HeaderContentSmall>
          {renderLines(copy.highlights.map((item) => `· ${item}`))}
        </HeaderContentSmall>

        <div style={{height: '20px'}}/>

        <SubHeading>{copy.solutionTitle}</SubHeading>

        <ImageTextPanel 
          Image={AutomotiveImage02}
          Title={solutionCopy.title}
          Link={solutionCopy.link}
          Text={<>{renderLines(solutionCopy.text)}</>}/>
{/* 
        <ImageTextPanel 
          Image={AutomotiveImage03}
          Title={'Sierra wireless'}
          Link={'http://www.sierrawireless.com'}
          Text={<>
            Automakers are using high-speed wireless connectivity to bring sophisticated software and services to the vehicle. <br></br>
            These IoT connections and the “Big Data” they generate can help OEMs continually improve their vehicles and <br></br>
            develop new applications to enhance the driving experience.
          </>}/> */}

      </HeaderContainer>
    </>
  )
}

export default Automotive
